export default {
    bingKey: 'ArTkP-DmMk_eLjH_bqre-RDkN7_9JZ2QikvOTgD7NcePeL4ARw3CLRnzalMJQn32',
    thunderforestKey: 'b8f914c789fc4c09a44f394941e39629',
    sentryDSN: '',
    mapillary: 'azJWOG1CVHUtUjdlSkVTMUF2WG91dzoyZmNhZmFjMzMyMmU2YzNi'
}



/** WEBPACK FOOTER **
 ** ./src/secrets.js
 **/